import React, { useEffect, useRef, useState } from "react";
import { grouplist, groupmemberlist, memberdetail, outstandinglist } from "../../../services/admin";
import exportUrl from "../../../exportUrl";
import { toast } from "react-toastify";
import moment from "moment";
import Select from "react-select";
import { branchmaster } from "../../../services/login";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const A4_WIDTH_PX = 794; // 210mm at 96dpi

export const NOCSheet = () => {
    const [glist, setGlist] = useState([]);
    const [grpid, setGrpId] = useState("");
    const [mgrpid, setMGrpId] = useState("");
    const [mlist, setMlist] = useState([]);
    const [memid, setMemId] = useState("");
    const [loandet, setLoanDet] = useState([]);
    const [loanid, setLoanId] = useState("");
    const [nocData, setNocData] = useState(null);
    const [branch, setBranch] = useState("");
    const nocRef = useRef();
    useEffect(() => {

        branchmaster().then((res) => {
            if (res.status === true) {
                const bdata = res.data.find((item) => item.id == localStorage.getItem("branch"));
                if (bdata) {
                    setBranch(bdata.branch_name);
                }
            }
        })

        const temp = new FormData();
        temp.append("branch", localStorage.getItem("branch"));
        grouplist(temp).then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.length > 0) {
                    for (let i = 0; i < res.data.length; i++) {
                        arr.push({
                            value: res.data[i].id,
                            label: res.data[i].group_name
                        })
                    }
                    setGlist(arr);
                }
            }
        })
    }, []);

    function handlegroup(e) {
        if (e !== null) {
            setMGrpId(e);
            setGrpId(e.value);
            setMemId("");
            setMlist([]);
            setLoanDet([]);
            setLoanId("");
            setNocData(null);
            if (e.value != "") {
                groupmemberlist(e.value).then((res) => {
                    if (res.status === true) {
                        setMlist(res.data);
                    }
                });
            }
        } else {
            setMGrpId("");
            setGrpId("");
            setMemId("");
            setMlist([]);
            setLoanDet([]);
            setLoanId("");
            setNocData(null);
        }

    }

    function handlemember(e) {
        setMemId(e.target.value);
        setLoanDet([]);
        setLoanId("");
        setNocData(null);
        if (e.target.value != "") {
            memberdetail(e.target.value).then((res) => {
                if (res.status === true) {
                    setLoanDet(res.data.loan_details);
                }
            })
        }
    }
    function handleLoan(e) {
        setNocData(null);
        const selectedLoanId = e.target.value;
        setLoanId(selectedLoanId);

        const selectedLoan = loandet.find(
            (item) => item.loan_entry_id == selectedLoanId
        );

        if (selectedLoan) {

            let finalPaymentDate = "Still Pending";

            if (selectedLoan.entries && selectedLoan.entries.length > 0) {
                const lastEntry = selectedLoan.entries[selectedLoan.entries.length - 1];

                if (
                    lastEntry.loanpaid !== null &&
                    lastEntry.loanpaid !== "0" &&
                    lastEntry.loanpaid !== ""
                ) {
                    finalPaymentDate = lastEntry.loan_paiddate;
                }
            }

            setNocData({
                member_name: mlist.find(m => m.id == memid)?.member_name || "",
                group_name: selectedLoan.group_name || "",
                loan_amount: selectedLoan.loan_amount,
                loan_date: selectedLoan.loan_date,
                final_payment_date: finalPaymentDate,
                no_of_dues: selectedLoan.no_of_dues
            });
        }
    }
    const downloadfile = async () => {
        if (grpid !== "") {
            if (memid !== "") {
                if (loanid !== "") {
                    const input = nocRef.current;

                    const canvas = await html2canvas(input, {
                        scale: 2, // Better quality
                        useCORS: true,
                        windowWidth: A4_WIDTH_PX,
                        // Capture at a fixed width so the certificate does not reflow
                        // with the browser window and change the PDF's proportions.
                        onclone: (doc, element) => {
                            element.style.width = `${A4_WIDTH_PX}px`;
                        }
                    });

                    const imgData = canvas.toDataURL("image/png");

                    const pdf = new jsPDF("p", "mm", "a4");

                    const pageWidth = 210; // A4 width
                    const pageHeight = 295;
                    const margin = 10;

                    let imgWidth = pageWidth - margin * 2;
                    let imgHeight = (canvas.height * imgWidth) / canvas.width;

                    // Shrink to fit rather than let the overflow fall off the page.
                    const maxHeight = pageHeight - margin * 2;
                    if (imgHeight > maxHeight) {
                        imgHeight = maxHeight;
                        imgWidth = (canvas.width * imgHeight) / canvas.height;
                    }

                    pdf.addImage(imgData, "PNG", (pageWidth - imgWidth) / 2, margin, imgWidth, imgHeight);

                    pdf.save(`NOC_${nocData.member_name}.pdf`);
                } else {
                    toast.error("Please Select Loan");
                }
            } else {
                toast.error("Please Select Member");
            }
        } else {
            toast.error("Please Select Group");
        }
    }
    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">NOC Report</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Report</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        NOC Report
                    </li>
                </ol>
            </div>

            <div className="content-body">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header">
                                <h2 className="main-content-title tx-24 mg-b-5">
                                    NOC Report
                                </h2>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-xl-4 col-sm-6">
                                        <div className="mb-6">
                                            <label className="form-label">
                                                Group<span className="text-danger"> *</span>
                                            </label>
                                            <Select
                                                className="default-select"
                                                placeholder="Select Select Group"
                                                value={mgrpid}
                                                options={glist}
                                                onChange={handlegroup}
                                                isSearchable={true}
                                                isClearable
                                                hidden
                                            />
                                            {/* <select
                                                className="default-select form-control wide"
                                                onChange={handlegroup}
                                                value={grpid}
                                            >
                                                <option value="" disabled>
                                                    Select Group
                                                </option>
                                                {glist.map((item, index) => {
                                                    return (
                                                        <option key={index} value={item.id}>
                                                            {item.group_name}
                                                        </option>
                                                    );
                                                })}
                                            </select> */}
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-sm-6">
                                        <div className="mb-6">
                                            <label className="form-label">
                                                Member<span className="text-danger"> *</span>
                                            </label>
                                            <select
                                                className="default-select form-control wide"
                                                onChange={handlemember}
                                                value={memid}
                                            >
                                                <option value="" disabled>
                                                    Select Member
                                                </option>
                                                {mlist.map((item, index) => {
                                                    return (
                                                        <option key={index} value={item.id}>
                                                            {item.member_name}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-sm-6">
                                        <div className="mb-6">
                                            <label className="form-label">
                                                Loan<span className="text-danger"> *</span>
                                            </label>
                                            <select
                                                className="default-select form-control wide"
                                                onChange={handleLoan}
                                                value={loanid}
                                            >
                                                <option value="" disabled>
                                                    Select Loan
                                                </option>
                                                {loandet.map((item, index) => {
                                                    return (
                                                        <option key={index} value={item.loan_entry_id}>
                                                            {item.scheme_name}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                    {nocData?.final_payment_date !== "Still Pending" && (
                                        <div className="col-xl-12 col-sm-6 mt-4">
                                            <div className="text-end">
                                                <a className="btn btn-danger me-2" onClick={downloadfile}>Download PDF</a>
                                            </div>
                                        </div>
                                    )}


                                </div>
                                {nocData && (
                                    <div ref={nocRef} className="mt-5 p-4 rounded">
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <img
                                                src={require("../../../assets/images/logo/service_logo.png")}
                                                alt="logo"
                                                style={{ width: "250px", height: "100px" }}
                                            />
                                        </div>
                                        <h4 className="text-center mb-4"><b>NO DUE CERTIFICATE</b></h4>


                                        <p><b>To</b></p>
                                        <p>
                                            The Branch Manager<br />
                                            Golden Global Credit Private Limited<br />
                                            {branch
                                                ? branch.charAt(0).toUpperCase() + branch.slice(1).toLowerCase()
                                                : ""} Branch

                                        </p>

                                        <p><b>Date:</b> {moment().format("DD.MM.YYYY")}</p>

                                        <p><b>Subject:</b> No Objection Certificate</p>

                                        <p>Dear Sir/Madam,</p>

                                        <p>
                                            Member Name: <b>{nocData.member_name}</b><br />
                                            Center Name: <b>{nocData.group_name}</b><br />
                                            Loan Amount: <b>{nocData.loan_amount}</b><br />
                                            Loan Disbursement Date: <b>{nocData.loan_date}</b>
                                        </p>


                                        <p>
                                            I humbly submit that I had availed a loan of
                                            <b> ₹{nocData.loan_amount}</b> from your esteemed company on <b>{nocData.loan_date}</b>.
                                        </p>
                                        <p>
                                            {nocData.final_payment_date === "Still Pending" ? (
                                                <>
                                                    I would like to inform you that my above-mentioned loan is
                                                    <b style={{ color: "red" }}> {nocData.final_payment_date}</b>.
                                                    Some installments are yet to be paid.
                                                    {/* I kindly request you to
      provide the updated outstanding details for the same. */}
                                                </>
                                            ) : (
                                                <>
                                                    I have successfully repaid the entire loan amount, and the final
                                                    installment was paid on
                                                    <b> {nocData.final_payment_date}</b>.
                                                    The total tenure of the loan was
                                                    <b> {nocData.no_of_dues} duration</b>.
                                                </>
                                            )}
                                        </p>

                                        <p>
                                            Since the loan has been fully settled, I kindly request you to issue
                                            the No Objection Certificate (NOC) confirming that there are no
                                            outstanding dues against the above-mentioned loan.
                                        </p>

                                        <p>Thanking you. </p>
                                        <p style={{ textTransform: "none" }}>
                                            <b>Golden Global Credit Private Limited<br />
                                                {branch
                                                    ? branch.charAt(0).toUpperCase() + branch.slice(1).toLowerCase()
                                                    : ""} Branch Manager </b>
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
